module.exports = {"index":"Sources Panel","addSource":"Add Customer Source","newSource":"New Customer Source Name","add":"Add","updateSource":"Update Customer Source","oriSource":"Original Customer Source Name","update":"Update","required":"Required","addSuccess":"Add Customer Source succeed","addFail":"Add Customer Source failed","updateSuccess":"Update Customer Source succeed","updateFail":"Update Customer Source failed","delSource":"Delete Customer Source","targetSource":"Delete Target","delete":"Delete"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/management/sources.json
// module id = FDhX
// module chunks = 58